import type { PublicQuestion } from '@geosport/shared';
import { SportIcon, sportLabel } from './SportIcon';

export function ClueCard({ question }: { question: PublicQuestion }) {
  return (
    <div
      className="animate-fade-up rounded-2xl bg-ink-2/95 p-4 shadow-xl ring-1 ring-white/10 backdrop-blur"
      data-testid="clue-card"
    >
      <div className="mb-1.5 flex items-center gap-2 text-[11px] font-bold tracking-[0.15em] text-white/50 uppercase">
        <SportIcon sport={question.sport} className="text-base" />
        {sportLabel(question.sport)}
      </div>
      <p className="text-[17px] leading-snug font-medium">{question.clue}</p>
    </div>
  );
}
